import { SendToast } from "@networkraildigitalfactory/components";

export const getPropsByAction = (action, selectedId, redirect, history, type) => {
  const actionSubject = type === "PDP" ? "development goal" : "objective";
  const actionType = type || "objectives";
  switch (action) {
    case "Cancel":
      return {
        message: "Any unsubmitted changes will be lost. Are you sure you want to cancel?",
        focusOnClose: "cancelBtn",
      };
    case "Delete":
      return {
        cancelText: "Back",
        confirmText: "Confirm deletion",
        message: `Deleting this draft will remove it from your ${actionType}. Do you wish to delete this draft?`,
        navTo: `/my-objectives/${actionType}`,
        toast: {
          success: "Your draft has been deleted.",
          error: "There was a problem deleting your draft. Please try again.",
        },
        focusOnClose:
          history.location.pathname === `/my-objectives/${actionType}`
            ? `${selectedId}Delete`
            : "deleteBtn",
      };
    case "Completed":
      return {
        cancelText: "Back",
        confirmText: "Mark as complete",
        confirmButtonColor: "green",
        message: `Your line manager will be able to see that you have marked this ${actionSubject} as complete. They will then have the opportunity to approve the completion.`,
        status: "employee complete",
        navTo: `/my-objectives/${actionType}`,
        toast: {
          success: `You have marked your ${actionSubject} as complete.`,
          error: `There was a problem marking your ${actionSubject} as completed. Please try again.`,
        },
        focusOnClose: "markCompleteBtn",
      };
    case "Approve":
      return {
        cancelText: "Back",
        confirmText: "Approve",
        message: `The ${actionSubject} will be marked as approved and your team member will be notified. Approvals cannot be undone but approved ${actionSubject}s can be cancelled.`,
        status: "approved",
        navTo: redirect,
        toast: {
          success: `You have marked the ${actionSubject} as approved.`,
          error: `There was a problem approving this ${actionSubject}. Please try again.`,
        },
        focusOnClose: "approveBtn",
      };
    case "LMCompleted":
      return {
        cancelText: "Back",
        confirmText: "Complete",
        message: `The ${actionSubject} will be marked as completed and your team member will be notified.`,
        status: "completed",
        navTo: redirect,
        toast: {
          success: `You have marked this ${actionSubject} as completed.`,
          error: `There was a problem marking this ${actionSubject} as completed. Please try again.`,
        },
        focusOnClose: "completeBtn",
      };
    default:
      return {};
  }
};

export const updateStatus = async (params) => {
  const { modalProps, isError, execute, history, close } = params;
  const { status, toast, navTo } = modalProps;
  await execute({
    data: {
      status,
    },
  });
  if (isError) {
    SendToast(toast.error, "error");
  } else {
    close();
    SendToast(toast.success, "success");
    history.push(navTo);
  }
};

export const deleteDraft = async (params) => {
  const { modalProps, isError, execute, history, close, type } = params;
  const { toast, navTo } = modalProps;
  await execute({});
  if (isError) {
    SendToast(toast.error, "error");
  } else {
    if (
      history.location.pathname.includes(
        `/view-${type === "PDP" ? "development-goal" : "objective"}`
      ) ||
      history.location.pathname.includes(
        `/edit-${type === "PDP" ? "development-goal" : "objective"}`
      )
    ) {
      close();
      history.push(navTo);
    } else {
      close();
    }
    SendToast(toast.success, "success");
  }
};
